@if (processingPurpose) {
    @if (processingPurpose.ID > 0) {
        <div class="detail-page-summary">
            <div class="row">
                <div class="col-6">
                    <div class="property"><b>{{ 'datamanagement.detailMain.summaryId' | transloco }}</b> {{ processingPurpose.ID }}</div>
                    <div class="property">
                        <b>{{ 'datamanagement.detailMain.summaryName' | transloco }}</b>&nbsp;<span data-uiid="dm-summary-name">{{
                            processingPurpose.name
                        }}</span>
                    </div>
                </div>
                <div class="col-6">
                    <div class="property">
                        <b>{{ 'datamanagement.detailMain.summaryDataSubject' | transloco }}</b> {{ processingPurpose.dataSubject || "None" }}
                    </div>
                    <div class="property">
                        <b>{{ 'datamanagement.detailMain.summaryMostRecentDpia' | transloco }}</b> {{ processingPurpose.dpiaDate | dateFormat }}
                    </div>
                </div>
            </div>
        </div>
    }
    <form [formGroup]="parentForm">
        <div class="detail-page-card">
            <div class="detail-page-card-title">{{ 'datamanagement.detailMain.processingDetailsTitle' | transloco }}</div>
            <div class="detail-page-card-body padded cerrix-control-sm">
                <div class="row">
                    <div class="col-12 col-xl-6 left-block">
                        <div class="row">
                            <div class="form-group col">
                                <cerrix-textfield
                                    [fieldLabel]="'datamanagement.detailMain.processingNameLabel' | transloco"
                                    dataUiid="dmdetailmain-processingname"
                                    identifier="name"
                                    formControlName="name"
                                    placeholder="Required"
                                ></cerrix-textfield>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12 col-lg-6">
                                <cerrix-textarea
                                    [fieldLabel]="'datamanagement.detailMain.descriptionLabel' | transloco"
                                    dataUiid="dmdetailmain-description"
                                    identifier="description"
                                    formControlName="description"
                                ></cerrix-textarea>
                            </div>
                            <div class="form-group col-12 col-lg-6">
                                <cerrix-textarea
                                    [fieldLabel]="'datamanagement.detailMain.purposeLabel' | transloco"
                                    dataUiid="dmdetailmain-purpose"
                                    identifier="purpose"
                                    formControlName="purpose"
                                ></cerrix-textarea>
                            </div>
                        </div>

                        <div class="form-group">
                            <cerrix-textarea
                                [fieldLabel]="'datamanagement.detailMain.securityMeasuresLabel' | transloco"
                                dataUiid="dmdetailmain-securitymeasures"
                                identifier="securityMeasures"
                                formControlName="securityMeasures"
                            ></cerrix-textarea>
                        </div>

                        <div class="form-group">
                            <label for="basisId">{{ 'datamanagement.detailMain.basisLabel' | transloco }}</label>
                            <cerrix-select
                                data-uiid="dmdetailmain-basis"
                                id="basisId"
                                formControlName="basisId"
                                prettyName="basis"
                                bindLabel="Name"
                                bindValue="ID"
                                [getDataMethod]="basisRequest"
                            >
                            </cerrix-select>
                        </div>

                        <div class="form-group">
                            <cerrix-textarea
                                [fieldLabel]="'datamanagement.detailMain.explanationBasisLabel' | transloco"
                                dataUiid="dmdetailmain-explanation"
                                identifier="explanationBasis"
                                formControlName="explanationBasis"
                            ></cerrix-textarea>
                        </div>
                    </div>

                    <div class="col-12 col-xl-6 right-block">
                        <hr class="d-xl-none" />

                        <div class="form-group">
                            <label>{{ 'datamanagement.detailMain.organizationLabel' | transloco }}</label>
                            <cerrix-select-tree
                                data-uiid="dmdetailmain-organization"
                                [getDataMethod]="organizationRequest"
                                formControlName="organizationId"
                                placeholder="Required"
                                [multiselect]="false"
                                (onChangeSingleId)="organizationChanged($event)"
                            >
                            </cerrix-select-tree>
                        </div>

                        <div class="form-group">
                            <label
                                >{{ 'datamanagement.detailMain.businessDimensionsLabel' | transloco }}
                                @if (selectedOrganizationId && !businessDimensionTreeItems) {
                                    <i class="fas fa-circle-notch fa-spin me-2"></i>
                                } @else if (!selectedOrganizationId) {
                                    <i
                                        class="far fa-question-circle ms-2"
                                        [matTooltip]="'Please select an organization first.'"
                                    ></i>
                                }
                            </label>
                            <cerrix-select-tree
                                data-uiid="dmdetailmain-businessdimensions"
                                [(tree)]="businessDimensionTreeItems"
                                formControlName="businessDimensionIds"
                                [multiselect]="true"
                                [readonly]="!selectedOrganizationId"
                                (onChangeIds)="businessDimensionsChanged($event)"
                            >
                            </cerrix-select-tree>
                        </div>

                        <div class="form-group">
                            <label
                                >{{ 'datamanagement.detailMain.frameworkDimensionsLabel' | transloco }}

                                @if (selectedOrganizationId && !frameworkDimensionTreeItems) {
                                    <i class="fas fa-circle-notch fa-spin me-2"></i>
                                } @else if (!selectedOrganizationId) {
                                    <i
                                        class="far fa-question-circle ms-2"
                                        [matTooltip]="'Please select an organization first.'"
                                    ></i>
                                }
                            </label>
                            <cerrix-select-tree
                                data-uiid="dmdetailmain-frameworkdimensions"
                                [(tree)]="frameworkDimensionTreeItems"
                                formControlName="frameworkDimensionIds"
                                [multiselect]="true"
                                [readonly]="!selectedOrganizationId"
                            >
                            </cerrix-select-tree>
                        </div>

                        <div class="row">
                            <div class="col-6">
                                <div class="form-group">
                                    <label for="removalIds">{{ 'datamanagement.detailMain.removalLabel' | transloco }}</label>
                                    <cerrix-select
                                        data-uiid="dmdetailmain-removal"
                                        id="removalIds"
                                        formControlName="removalIds"
                                        prettyName="removal types"
                                        bindLabel="Name"
                                        bindValue="ID"
                                        [closeOnSelect]="false"
                                        [multiple]="true"
                                        [getDataMethod]="removalRequest"
                                    >
                                    </cerrix-select>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label for="sensitivityIds">{{ 'datamanagement.detailMain.sensitivityOfProcessingLabel' | transloco }}</label>
                                    <cerrix-select
                                        data-uiid="dmdetailmain-sensitivity"
                                        id="sensitivityIds"
                                        formControlName="sensitivityIds"
                                        prettyName="sensitivity of processing"
                                        bindLabel="Name"
                                        bindValue="ID"
                                        [closeOnSelect]="false"
                                        [multiple]="true"
                                        [getDataMethod]="sensitivityRequest"
                                    >
                                    </cerrix-select>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <cerrix-textfield
                                [fieldLabel]="'datamanagement.detailMain.generalArchivePolicyLabel' | transloco"
                                dataUiid="dmdetailmain-generalarchivepolicy"
                                identifier="generalArchivePolicy"
                                formControlName="generalArchivePolicy"
                                placeholder="Required"
                            ></cerrix-textfield>
                        </div>

                        <div class="row">
                            <div class="col-12 col-lg-6">
                                <cerrix-checkbox
                                    data-uiid="dmdetailmain-profiling"
                                    [label]="'datamanagement.detailMain.profilingLabel' | transloco"
                                    formControlName="profiling"
                                    fontsize="0.9em"
                                >
                                </cerrix-checkbox>
                            </div>
                            <div class="col-12 col-lg-6">
                                <cerrix-checkbox
                                    data-uiid="dmdetailmain-dataanalytics"
                                    [label]="'datamanagement.detailMain.dataAnalyticsLabel' | transloco"
                                    formControlName="dataAnalytics"
                                    fontsize="0.9em"
                                >
                                </cerrix-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-xl-6">
                @if (recipientConfig) {
                    <generic-list-manager [config]="recipientConfig" idProp="id">
                    </generic-list-manager>
                }
            </div>

            <div class="col-12 col-xl-6">
                @if (sourceDeliveryConfig) {
                    <generic-list-manager [config]="sourceDeliveryConfig" idProp="id">
                    </generic-list-manager>
                }
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-xl-6">
                <div class="detail-page-card">
                    <div class="detail-page-card-title">
                        {{ 'datamanagement.detailMain.stakeholdersTitle' | transloco }}
                        <i
                            class="far fa-exclamation-circle ms-2"
                            [matTooltip]="
                                'datamanagement.detailMain.stakeholderInheritedTooltip' | transloco
                            "
                        ></i>
                    </div>
                    <div class="detail-page-card-body padded cerrix-control-sm">
                        <div class="form-group">
                            <label>{{ 'datamanagement.detailMain.dataSubjectsLabel' | transloco }}</label>
                            <cerrix-select
                                data-uiid="dmdetailmain-datasubjects"
                                [getDataMethod]="dataSubjectsRequest"
                                [value]="processingPurpose.dataSubjectIds"
                                [multiple]="true"
                                [disabled]="true"
                            >
                            </cerrix-select>
                        </div>
                        <div class="form-group">
                            <label for="dataControllerSelect">{{ 'datamanagement.detailMain.dataControllersLabel' | transloco }}</label>
                            <cerrix-select
                                data-uiid="dmdetailmain-datacontrollers"
                                id="dataControllerSelect"
                                prettyName="data controller(s)"
                                bindValue="ID"
                                [value]="processingPurpose.dataControllerIds"
                                [ngModelOptions]="{ standalone: true }"
                                [multiple]="true"
                                [disabled]="true"
                                [getDataMethod]="dataControllerRequest"
                            >
                            </cerrix-select>
                        </div>

                        <div class="form-group">
                            <label for="dataProcessorSelect">{{ 'datamanagement.detailMain.dataSubProcessorsLabel' | transloco }}</label>
                            <cerrix-select
                                data-uiid="dmdetailmain-datasubprocessors"
                                id="dataProcessorSelect"
                                name="dataProcessorSelect"
                                prettyName="data (sub)processor(s)"
                                bindValue="ID"
                                [value]="processingPurpose.dataProcessorIds"
                                [ngModelOptions]="{ standalone: true }"
                                [multiple]="true"
                                [disabled]="true"
                                [getDataMethod]="dataSubProcessorRequest"
                            >
                            </cerrix-select>
                        </div>

                        <div class="form-group">
                            <label for="thirdPartyIds">{{ 'datamanagement.detailMain.thirdPartiesLabel' | transloco }}</label>
                            <cerrix-select
                                data-uiid="dmdetailmain-thirdparties"
                                id="thirdPartyIds"
                                formControlName="thirdPartyIds"
                                prettyName="third parties"
                                bindValue="ID"
                                [closeOnSelect]="false"
                                [multiple]="true"
                                [getDataMethod]="thirdPartiesRequest"
                            >
                            </cerrix-select>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-xl-6">
                <div class="detail-page-card">
                    <div class="detail-page-card-title">{{ 'datamanagement.detailMain.dataPrivacyImpactAssessmentTitle' | transloco }}</div>
                    <div class="detail-page-card-body padded cerrix-control-sm">
                        <div class="row">
                            <div class="col">
                                <cerrix-checkbox
                                    data-uiid="dmdetailmain-dpiarequired"
                                    [label]="'datamanagement.detailMain.dpiaRequiredLabel' | transloco"
                                    formControlName="dpiaRequired"
                                    fontsize="0.9em"
                                >
                                </cerrix-checkbox>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-6">
                                <div class="form-group">
                                    <label>{{ 'datamanagement.detailMain.mostRecentDpiaLabel' | transloco }}</label>
                                    <date-input
                                        data-uiid="dmdetailmain-mostrecentdpia"
                                        formControlName="dpiaDate"
                                        [maxDate]="maxDate"
                                    ></date-input>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <cerrix-textfield
                                        [fieldLabel]="'datamanagement.detailMain.dpiaReferenceLabel' | transloco"
                                        dataUiid="dmdetailmain-dpiareference"
                                        identifier="dpiaReference"
                                        formControlName="dpiaReference"
                                    ></cerrix-textfield>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <cerrix-textarea
                                [fieldLabel]="'datamanagement.detailMain.latestConclusionDpiaLabel' | transloco"
                                dataUiid="dmdetailmain-latestconclusiondpia"
                                identifier="dpiaConclusion"
                                formControlName="dpiaConclusion"
                            ></cerrix-textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
}
